import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const included = ['Airport transfers and private ground transport as listed', 'One Kathmandu night in a carefully selected 4-star hotel', 'All meals on trek: breakfast, lunch and dinner', 'Licensed Manaslu guide, porter support and guide insurance', 'Tea-house accommodation throughout the trekking route', 'Manaslu Restricted Area, MCAP and ACAP permits', 'First-aid kit, trek briefing and emergency support coordination'];
const excluded = ['International flights, Nepal visa and travel insurance', 'Personal trekking equipment, snacks and bottled drinks', 'Hot showers, Wi-Fi, charging and laundry at mountain lodges', 'Tips for guides, porters and drivers', 'Additional accommodation caused by weather or personal changes', 'Alcohol, personal purchases and meals not stated in the itinerary'];
const addOnPackages = [['Kathmandu UNESCO World Heritage Sightseeing Tour (Private)', 'US$90 per day'], ['Upgrade to 4-Star Hotel in Kathmandu', 'US$60 per room, per night'], ['Upgrade to 5-Star Luxury Hotel in Kathmandu', 'From US$150 per room, per night'], ['Private Jeep Transfer: Kathmandu – Macha Khola', 'US$300 per vehicle (one way)']];
export function Pricing() {
  return <section id="departures" className="bg-[#e9e3d5] py-20 text-[#1d2d2a] sm:py-28" data-id="element-287" data-mp="eqjzh58arkn6">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10" data-id="element-288" data-mp="3d6upslw4ke3q">
        <div className="max-w-3xl" data-id="element-289" data-mp="3i93idh535e5b">
          <p className="eyebrow" data-id="element-290" data-mp="3i5xxyf7ej0fx">Clear, considered pricing</p>
          <h2 className="mt-4 font-display text-4xl leading-tight sm:text-5xl" data-id="element-291" data-mp="3n63p7u9rekxh">
            A small group makes the mountain more attainable.
          </h2>
          <p className="mt-5 text-base leading-8 text-[#55615a]" data-id="element-292" data-mp="2uihcnwik05yh">
            Your trek cost reflects the permits, local expertise, transport,
            food and careful logistics required in a restricted Himalayan
            region. A solo departure carries a higher price because the fixed
            guide, vehicle and permit administration costs are not shared. Join
            another walker—or bring a friend—and the group rate applies.
          </p>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-293" data-mp="318qycq7oroih">
          <article className="border border-[#bcb3a1] bg-[#f7f4ec] p-7" data-id="element-294" data-mp="2w8mj13iikztu">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#6D5A39]" data-id="element-295" data-mp="28hqxgo4nj0v1">
              Private solo departure
            </p>
            <p className="mt-5 font-display text-5xl" data-id="element-296" data-mp="23kgwcb7wh0rd">US$1,560</p>
            <p className="mt-4 max-w-md text-sm leading-6 text-[#55615a]" data-id="element-297" data-mp="2igpvzdvpdg4b">
              For one traveler requesting a dedicated departure. The solo
              premium covers fixed operational costs that cannot be shared on a
              private trek.
            </p>
          </article>
          <article className="bg-[#172a27] p-7 text-[#f4f0e7]" data-id="element-298" data-mp="3ows3dp5nomt5">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D9CAA0]" data-id="element-299" data-mp="3oycxjdo263qh">
              Two or more travelers
            </p>
            <p className="mt-5 font-display text-5xl" data-id="element-300" data-mp="5a00j6ignluz">
              US$1,165 <span className="text-xl" data-id="element-301" data-mp="5740ncn1yn3w">pp</span>
            </p>
            <p className="mt-4 max-w-md text-sm leading-6 text-stone-300" data-id="element-302" data-mp="3ngeirhnrihz6">
              Our group price for double occupancy and small groups. Shared
              logistics mean more value, while groups remain intentionally small
              and guided with care.
            </p>
          </article>
        </div>

        <div className="mt-12 grid gap-10 lg:grid-cols-2" data-id="element-303" data-mp="nz6i2q7iq7f7">
          <div data-id="element-304" data-mp="a9csg5o6vj4f">
            <h3 className="font-display text-3xl" data-id="element-305" data-mp="a7s1eq132ibb">What’s included</h3>
            <ul className="mt-6 space-y-3" data-id="element-306" data-mp="e9mxng45q5i8">
              {included.map(item => <li key={item} className="flex gap-3 text-sm leading-6 text-[#46534c]" data-id="element-307" data-mp="11zzfbip7fgm0">
                  <CheckIcon size={18} className="mt-1 shrink-0 text-[#6D5A39]" aria-hidden="true" data-id="element-308" data-mp="16r91uafgi3to" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-309" data-mp="358kn2fe0issw">
            <h3 className="font-display text-3xl" data-id="element-310" data-mp="35adys93hg37r">What’s not included</h3>
            <ul className="mt-6 space-y-3" data-id="element-311" data-mp="31893z71at0jj">
              {excluded.map(item => <li key={item} className="flex gap-3 text-sm leading-6 text-[#46534c]" data-id="element-312" data-mp="1scidbjy9k5z">
                  <XIcon size={18} className="mt-1 shrink-0 text-[#6D5A39]" aria-hidden="true" data-id="element-313" data-mp="3t085sa14exk3" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <section className="mt-16 border-y border-[#bcb3a1] py-12 text-center sm:py-14" aria-labelledby="add-on-packages-title" data-id="element-314" data-mp="kjdc9l67qpio">
          <div className="mx-auto max-w-3xl" data-id="element-315" data-mp="fqk931qe7p8p">
            <p className="eyebrow" data-id="element-316" data-mp="1yg6lp8qbukug">Make the journey your own</p>
            <h3 id="add-on-packages-title" className="mt-3 font-display text-3xl sm:text-4xl" data-id="element-317" data-mp="23e821lwdc628">
              Optional add-on packages
            </h3>
            <p className="mt-4 text-sm leading-7 text-[#55615a] sm:text-base" data-id="element-318" data-mp="2cewjkqkz0ojv">
              Enhance your Manaslu Circuit Trek with optional stays, transfers,
              cultural experiences, and personal porter support.
            </p>
          </div>

          <div className="mx-auto mt-8 max-w-3xl border-t border-[#c8c1af]" data-id="element-319" data-mp="2mbssuyip1eph">
            {addOnPackages.map(([service, price]) => <article key={service} className="border-b border-[#c8c1af] py-5" data-id="element-320" data-mp="2r66jyoqbozoc">
                <h4 className="text-sm font-semibold leading-6 text-[#1d2d2a]" data-id="element-321" data-mp="2v4mgpkc7hmey">
                  {service}
                </h4>
                <p className="mt-2 text-xs font-bold leading-5 text-[#6D5A39] sm:text-sm" data-id="element-322" data-mp="353lfmb7663or">
                  {price}
                </p>
              </article>)}
          </div>
        </section>

        <div className="mt-14 flex flex-col items-center justify-center gap-4 border-t border-[#bcb3a1] pt-10 sm:flex-row" data-id="element-323" data-mp="102izxhb6veg7">
          <Link to="/book-now" className="inline-flex w-full items-center justify-center bg-[#172a27] px-7 py-4 text-sm font-bold text-[#f4f0e7] transition-colors hover:bg-[#314940] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A48C5A] focus-visible:ring-offset-4 sm:w-auto" data-id="element-324" data-mp="1es70ggbjq92v">
            Book now
          </Link>
          <Link to="/contact" className="inline-flex w-full items-center justify-center border border-[#6D5A39] px-7 py-4 text-sm font-bold text-[#1d2d2a] transition-colors hover:bg-[#f7f4ec] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A48C5A] focus-visible:ring-offset-4 sm:w-auto" data-id="element-325" data-mp="1xpzpqft8ykhs">
            Inquiry
          </Link>
        </div>
      </div>
    </section>;
}